// extracted by mini-css-extract-plugin
export default {"root":"TableAttribute_root__LrZcm","tbl":"TableAttribute_tbl__EdFqW","th":"TableAttribute_th__7GXyJ","td":"TableAttribute_td__gGpXX"};